var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7511 6.49037L19.1897 11.663C19.3092 11.923 19.5446 12.1047 19.8184 12.1485L25.2766 12.9809C25.4981 13.0128 25.6982 13.1354 25.8323 13.3215C25.9665 13.5076 26.0236 13.7417 25.991 13.9718C25.9636 14.161 25.8765 14.3353 25.7434 14.4673L21.7902 18.5103C21.5904 18.7095 21.5008 19.0002 21.5521 19.2832L22.5046 24.981C22.5736 25.4505 22.2686 25.891 21.8188 25.9719C21.6333 26.0022 21.4433 25.971 21.2758 25.8827L16.4082 23.1973C16.165 23.0581 15.8702 23.0581 15.6271 23.1973L10.7308 25.9026C10.32 26.1218 9.81611 25.9588 9.59727 25.5359C9.51195 25.3654 9.48188 25.1707 9.51154 24.981L10.4641 19.2832C10.5102 19.0006 10.4214 18.7123 10.226 18.5103L6.24422 14.4673C5.91859 14.1239 5.91859 13.5721 6.24422 13.2286C6.37711 13.1006 6.54233 13.0147 6.72051 12.9809L12.1787 12.1485C12.4513 12.1015 12.6853 11.9208 12.8074 11.663L15.246 6.49037C15.3424 6.28063 15.5161 6.12026 15.7277 6.04564C15.9393 5.97101 16.171 5.98845 16.3701 6.094C16.5343 6.18066 16.6678 6.31949 16.7511 6.49037Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStar);
export default __webpack_public_path__ + "static/media/activeStar.a016628338e89d25f8636aa04aba4723.svg";
export { ForwardRef as ReactComponent };